export const reduxKey = '@@HEAD';

//# sourceMappingURL=constants.js.map